import { render, staticRenderFns } from "./duplicateremovalPending.vue?vue&type=template&id=767d6a35&scoped=true&"
import script from "./duplicateremovalPending.vue?vue&type=script&lang=js&"
export * from "./duplicateremovalPending.vue?vue&type=script&lang=js&"
import style0 from "./duplicateremovalPending.vue?vue&type=style&index=0&id=767d6a35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d6a35",
  null
  
)

export default component.exports